import { render, staticRenderFns } from "./ReportDailyTotalsDetailsRow.vue?vue&type=template&id=435ea557&scoped=true&"
import script from "./ReportDailyTotalsDetailsRow.vue?vue&type=script&lang=js&"
export * from "./ReportDailyTotalsDetailsRow.vue?vue&type=script&lang=js&"
import style0 from "./ReportDailyTotalsDetailsRow.vue?vue&type=style&index=0&id=435ea557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435ea557",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VRow,VSimpleTable})
